export default __webpack_public_path__ + "static/group-order-do-46ac5b97c15996a6cc45a0ba0cd1e516.png";